import React from 'react';
import styled from 'styled-components';

interface SplitButtonProps {
  onSplit: () => void;
}

export const SplitButton: React.FC<SplitButtonProps> = ({ onSplit }) => {
  return (
    <StyledButton onClick={onSplit} title="Split element at playhead">
      <SplitIcon />
    </StyledButton>
  );
};

const StyledButton = styled.button`
  background-color: #333;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 10px;
  margin: 0 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background-color: #444;
  }
`;

const SplitIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2v20M6 12H2M22 12h-4" />
  </svg>
);